<div class="billing-month page-b4a">
  <header class="billing-month__header">
    <div class="billing-month__intro">
      <h1>Acompanhamento do Mês</h1>
      <p class="billing-month__subtitle">
        Como a cobrança de assinatura do mês está andando: quanto já converteu,
        quanto foi recusado e o que ainda está em processamento.
      </p>
    </div>

    <form [formGroup]="monthForm" class="form-b4a billing-month__filters">
      <button
        pButton
        type="button"
        icon="pi pi-chevron-left"
        class="p-button-text p-button-rounded"
        pTooltip="Mês anterior"
        tooltipPosition="bottom"
        (click)="goToPreviousMonth()"
      ></button>
      <span class="p-float-label">
        <p-calendar
          inputId="billing-month-month"
          formControlName="month"
          view="month"
          dateFormat="mm/yyyy"
          [maxDate]="maxMonth"
          [readonlyInput]="true"
          [showIcon]="true"
          (onSelect)="loadMonth()"
        />
        <label for="billing-month-month">Mês</label>
      </span>
      <button
        pButton
        type="button"
        icon="pi pi-chevron-right"
        class="p-button-text p-button-rounded"
        pTooltip="Mês seguinte"
        tooltipPosition="bottom"
        (click)="goToNextMonth()"
      ></button>
      <button
        pButton
        type="button"
        label="Atualizar"
        icon="pi pi-refresh"
        class="p-button-outlined"
        (click)="loadMonth()"
      ></button>
    </form>
  </header>

  <p-message
    *ngIf="loadFailed"
    severity="error"
    text="Não foi possível carregar o mês. Os indicadores ficam ocultos para não exibir número zerado como se fosse resultado real. Tente atualizar."
  />

  <div
    class="billing-month__empty"
    *ngIf="!loadFailed && report && report.totals.total === 0"
  >
    <i class="pi pi-inbox"></i>
    <h2>Nenhuma cobrança executada em {{ selectedMonthLabel }}</h2>
    <p>
      Quando o primeiro lote do mês rodar, os indicadores aparecem aqui
      automaticamente.
    </p>
  </div>

  <ng-container *ngIf="!loadFailed && report && report.totals.total > 0">
    <section class="billing-month__cards">
      <article
        class="billing-month__card"
        *ngFor="let card of cards"
        [ngClass]="'billing-month__card--' + card.tone"
      >
        <span class="billing-month__card-label">
          {{ card.label }}
          <i
            class="pi pi-info-circle"
            [pTooltip]="card.hint"
            tooltipPosition="top"
          ></i>
        </span>
        <strong class="billing-month__card-value">{{ card.value }}</strong>
      </article>
    </section>

    <section class="billing-month__panel">
      <header class="billing-month__panel-header">
        <h2>Andamento de {{ selectedMonthLabel }}</h2>
        <span class="billing-month__panel-hint">
          Acumulado a cada lote executado, na ordem em que rodaram.
        </span>
      </header>
      <div class="billing-month__chart">
        <p-chart
          type="line"
          [data]="timelineChartData"
          [options]="volumeChartOptions"
        />
      </div>
    </section>

    <section class="billing-month__panel">
      <header class="billing-month__panel-header">
        <h2>Resultado por tentativa</h2>
        <span class="billing-month__panel-hint">
          A conversão considera só cobranças com desfecho. Margem compara cada
          tentativa com a primeira do mês.
        </span>
      </header>
      <div class="billing-month__chart">
        <p-chart
          type="bar"
          [data]="attemptChartData"
          [options]="stackedChartOptions"
        />
      </div>
      <app-table
        [lazy]="false"
        [elements]="attempts"
        [cols]="attemptCols"
        [paginator]="false"
        [addButton]="false"
        [exportExcel]="false"
        [exportPdf]="false"
        [showTitle]="false"
        modelName="tentativas"
      />
    </section>

    <section class="billing-month__panel">
      <header class="billing-month__panel-header">
        <h2>Motivos de recusa</h2>
        <span class="billing-month__panel-hint">
          Escolha um lote com recusas para carregar os motivos daquele lote.
        </span>
      </header>

      <form [formGroup]="refusalForm" class="form-b4a">
        <span class="p-float-label">
          <p-dropdown
            inputId="billing-month-round"
            formControlName="paymentRoundId"
            [options]="roundOptions"
            optionLabel="label"
            optionValue="paymentRoundId"
            [filter]="true"
            filterBy="label"
            [showClear]="true"
            placeholder="Selecione um lote"
            [style]="{ minWidth: '22rem' }"
            (onChange)="loadRefusalReasons()"
          />
          <label for="billing-month-round">Lote com recusas</label>
        </span>
      </form>

      <p
        class="billing-month__panel-empty"
        *ngIf="roundOptions.length === 0"
      >
        Nenhum lote do mês registrou recusa.
      </p>

      <ng-container *ngIf="refusalReasons.length > 0">
        <span class="billing-month__panel-hint">{{ refusalRoundLabel }}</span>
        <div class="billing-month__chart billing-month__chart--reasons">
          <p-chart
            type="bar"
            [data]="refusalChartData"
            [options]="refusalChartOptions"
          />
        </div>
        <app-table
          [lazy]="false"
          [elements]="refusalReasons"
          [cols]="refusalCols"
          [paginator]="false"
          [addButton]="false"
          [exportExcel]="false"
          [exportPdf]="false"
          [showTitle]="false"
          modelName="motivos"
        />
      </ng-container>
    </section>
  </ng-container>

  <section
    class="billing-month__panel billing-month__gateway"
    aria-labelledby="billing-month-gateway-title"
  >
    <header class="billing-month__panel-header">
      <h2 id="billing-month-gateway-title">Aprovação por gateway</h2>
      <span class="billing-month__panel-hint">
        Pagos, recusados e em voo de cada gateway no mês selecionado. A taxa de
        aprovação usa só cobranças com desfecho. O seletor de tentativa filtra
        só esta seção.
      </span>
    </header>

    <form [formGroup]="gatewayForm" class="form-b4a">
      <span class="p-float-label">
        <p-dropdown
          inputId="billing-month-gateway-attempt"
          formControlName="attempt"
          [options]="gatewayAttemptOptions"
          optionLabel="label"
          optionValue="value"
          [style]="gatewayAttemptDropdownStyle"
          (onChange)="loadGatewayReport()"
        />
        <label for="billing-month-gateway-attempt">Tentativa</label>
      </span>
    </form>

    <p-message
      *ngIf="gatewayLoadFailed"
      severity="error"
      text="Não foi possível carregar a aprovação por gateway. O restante do mês continua na tela."
    />

    <p class="billing-month__gateway-loading" *ngIf="gatewayLoading">
      Carregando aprovação por gateway.
    </p>

    <p
      class="billing-month__panel-empty"
      *ngIf="!gatewayLoading && !gatewayLoadFailed && gatewaySection.isEmpty"
    >
      Nenhum lote executado no mês
    </p>

    <ng-container
      *ngIf="
        !gatewayLoading && !gatewayLoadFailed && gatewaySection.rows.length > 0
      "
    >
      <app-table
        [lazy]="false"
        [elements]="gatewaySection.rows"
        [cols]="gatewayCols"
        [paginator]="false"
        [addButton]="false"
        [exportExcel]="false"
        [exportPdf]="false"
        [showTitle]="false"
        modelName="gateways"
      />

      <div
        class="billing-month__gateway-outside"
        *ngIf="gatewaySection.withoutGateway"
      >
        <div class="billing-month__gateway-outside-heading">
          <strong>{{ gatewaySection.withoutGateway.gatewayName }}</strong>
          <span class="billing-month__gateway-note">
            Esta linha não entra na taxa de aprovação nem na participação.
          </span>
        </div>
        <dl class="billing-month__gateway-outside-metrics">
          <div>
            <dt>Assinantes</dt>
            <dd>{{ gatewaySection.withoutGateway.distinctSubscribers }}</dd>
          </div>
          <div>
            <dt>Pagos</dt>
            <dd>{{ gatewaySection.withoutGateway.paid }}</dd>
          </div>
          <div>
            <dt>Recusados</dt>
            <dd>{{ gatewaySection.withoutGateway.refused }}</dd>
          </div>
          <div>
            <dt>Em voo</dt>
            <dd>{{ gatewaySection.withoutGateway.inFlight }}</dd>
          </div>
          <div>
            <dt>Taxa de aprovação</dt>
            <dd>{{ gatewaySection.withoutGateway.approvalRatePercent }}</dd>
          </div>
          <div>
            <dt>Participação</dt>
            <dd>{{ gatewaySection.withoutGateway.sharePercent }}</dd>
          </div>
        </dl>
      </div>
    </ng-container>
  </section>
</div>
